module.exports = __webpack_public_path__ + "static/masonry-image-1-e6d260a7605a7a1fb92eaf95141b055b.jpg";